import React from 'react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import desktopLogo from '../assets/Desktop.webp';


const Navbar = () => {
  return (
    <nav className="bg-transparent w-full h-20 sm:px-6 py-4 flex justify-between items-center">

      {/* Logo - Switch based on screen size */}
      <div className="flex items-center">
        {/* Desktop Logo */}
        <img src={desktopLogo} alt="Abhi Logo" className="hidden sm:block " />
        {/* Mobile Logo */}
        <img src={desktopLogo} alt="Abhi Logo" className="block sm:hidden " />
      </div>

      {/* Social Icons */}
      <div className="flex items-center gap-4 text-[28px] sm:text-[32px] text-gray-700">
        <a 
          href="https://www.linkedin.com/in/abhiramgargeya/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-gray-600 hover:text-sky-700 hover:scale-110 transition-all duration-300 ease-in-out"
        >
          <FaLinkedin size={28} />
        </a>
        <a 
          href="https://github.com/AbhiramGarg/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-gray-600 hover:text-gray-900 hover:scale-110 transition-all duration-300 ease-in-out"
        >
          <FaGithub size={28} />
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
